import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  RadioButtonUnchecked as PendingCircleIcon,
} from '@mui/icons-material';

const ApprovalDot = ({ status, label }) => {
  const icon =
    status === 'approved' ? <CheckCircleIcon sx={{ fontSize: 22, color: 'success.main' }} /> :
    status === 'rejected' ? <CancelIcon sx={{ fontSize: 22, color: 'error.main' }} /> :
    <PendingCircleIcon sx={{ fontSize: 22, color: 'grey.400' }} />;

  return (
    <Box sx={{ flex: 1, textAlign: 'center' }}>
      {icon}
      <Typography variant="caption" display="block" sx={{ fontSize: '0.6rem', color: 'text.secondary', mt: 0.25 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default ApprovalDot;
